import { useState, useEffect} from 'react';
import { useNavigate } from 'react-router-dom';
import { FaLinkedin, FaEnvelope } from 'react-icons/fa';


function ContactPage(){
return(
    <div>
    <h3><a href ="https://www.linkedin.com/in/trish-stackpole/">Connect with me on LinkedIn</a></h3>
    <h3><a href="mailto:trish@stackpop.dev">Send me email</a></h3>
    <h3><a href="https://github.com/stackpop2010/">Check out my Github</a></h3>

    </div>
)

}

export default ContactPage; 